var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ASSETS_PREFIX, URLS, UrlUtils } from '../api/urls';
class Oauth {
    constructor() {
        this.disposeCalls = [];
        this.signInError = Oauth.takeSignInError();
        this.button = document.getElementById('oauth-button');
        this.button.classList.remove('is-hidden');
        {
            this.icon = document.createElement('span');
            this.icon.className = 'oauth-button-icon';
            this.button.appendChild(this.icon);
        }
        {
            const onClick = () => this.click();
            this.button.addEventListener('click', onClick);
            this.disposeCalls.push(() => this.button.removeEventListener('click', onClick));
        }
        this.loaded = this.checkStatus();
        if (this.signInError) {
            const reason = this.signInError;
            this.signInError = undefined;
            this.loaded.then(() => this.showSignInError(reason));
        }
    }
    static takeSignInError() {
        const params = new URLSearchParams(window.location.search);
        const error = params.get('oauth_error');
        if (!error)
            return undefined;
        params.delete('oauth_error');
        const query = params.toString();
        window.history.replaceState({}, '', window.location.pathname + (query ? `?${query}` : ''));
        return error;
    }
    loadUserInfo() {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield fetch(URLS.OAUTH_INFO, { method: 'POST' });
            if (result.ok)
                return (yield result.json());
            else
                return undefined;
        });
    }
    checkStatus() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, _reject) => __awaiter(this, void 0, void 0, function* () {
                try {
                    this.userInfo = yield this.loadUserInfo();
                    this.updateButtonIcon();
                    resolve(undefined);
                }
                catch (e) {
                    resolve(e);
                }
            }));
        });
    }
    updateButtonIcon() {
        var _a, _b;
        const provider = (_b = (_a = this.userInfo) === null || _a === void 0 ? void 0 : _a.provider) === null || _b === void 0 ? void 0 : _b.toLowerCase();
        const iconName = provider ? Oauth.PROVIDER_ICONS[provider] : undefined;
        if (iconName) {
            this.icon.style.setProperty('--oauth-provider-icon', `url('${ASSETS_PREFIX}/assets/img/icons/${iconName}.svg')`);
            this.icon.classList.add('oauth-button-icon--provider');
        }
        else {
            this.icon.classList.remove('oauth-button-icon--provider');
            this.icon.style.removeProperty('--oauth-provider-icon');
        }
    }
    signOut() {
        return __awaiter(this, void 0, void 0, function* () {
            this.hidePopup();
            try {
                yield fetch(URLS.OAUTH_SIGN_OUT, { method: 'POST' });
            }
            finally {
                this.userInfo = undefined;
                this.updateButtonIcon();
            }
        });
    }
    deleteAccount() {
        return __awaiter(this, void 0, void 0, function* () {
            this.hidePopup();
            try {
                yield fetch(URLS.OAUTH_DELETE_ACCOUNT, { method: 'POST', headers: { Accept: 'application/json' } });
            }
            finally {
                this.userInfo = undefined;
                this.updateButtonIcon();
            }
        });
    }
    click() {
        this.loaded.then(() => {
            if (this.userInfo === undefined)
                this.redirectToSignIn();
            else
                this.showUserInfo();
        });
    }
    redirectToSignIn() {
        var _a;
        const returnTo = window.location.pathname + window.location.search;
        const url = UrlUtils.insertValueToUrl(URLS.OAUTH_SIGN_IN, encodeURIComponent(returnTo));
        const target = (_a = window.top) !== null && _a !== void 0 ? _a : window;
        try {
            target.location.assign(url);
        }
        catch (_b) {
            window.location.assign(url);
        }
    }
    showSignInError(reason) {
        if (this.popup)
            this.hidePopup();
        const popup = document.createElement('div');
        popup.className = 'oauth-popup oauth-popup--error';
        const title = document.createElement('div');
        title.className = 'oauth-popup-title';
        title.textContent = 'Sign-in failed';
        popup.appendChild(title);
        const text = document.createElement('div');
        text.className = 'oauth-popup-error-reason';
        text.textContent = reason.replace(/_/g, ' ');
        popup.appendChild(text);
        this.presentPopup(popup);
    }
    showUserInfo() {
        var _a, _b;
        if (this.popup) {
            this.hidePopup();
            return;
        }
        const popup = document.createElement('div');
        popup.className = 'oauth-popup';
        {
            const title = document.createElement('div');
            title.className = 'oauth-popup-title';
            title.textContent = (_b = (_a = this.userInfo.email) !== null && _a !== void 0 ? _a : this.userInfo.nickname) !== null && _b !== void 0 ? _b : '';
            popup.appendChild(title);
        }
        {
            const provider = document.createElement('div');
            provider.className = 'oauth-popup-provider';
            const providerName = this.userInfo.provider;
            const iconName = Oauth.PROVIDER_ICONS[providerName === null || providerName === void 0 ? void 0 : providerName.toLowerCase()];
            if (iconName) {
                const icon = document.createElement('span');
                icon.className = 'oauth-popup-provider-icon';
                icon.style.setProperty('--oauth-provider-icon', `url('${ASSETS_PREFIX}/assets/img/icons/${iconName}.svg')`);
                provider.appendChild(icon);
            }
            const text = document.createElement('div');
            text.className = 'oauth-popup-provider-text';
            const label = document.createElement('span');
            label.className = 'oauth-popup-provider-label';
            label.textContent = 'Connected with';
            text.appendChild(label);
            const name = document.createElement('span');
            name.className = 'oauth-popup-provider-name';
            name.textContent = providerName;
            text.appendChild(name);
            provider.appendChild(text);
            popup.appendChild(provider);
        }
        {
            const logOut = document.createElement('button');
            logOut.className = 'oauth-popup-log-out';
            const icon = document.createElement('span');
            icon.className = 'oauth-popup-log-out-icon';
            logOut.appendChild(icon);
            const text = document.createElement('span');
            text.textContent = 'Log out';
            logOut.appendChild(text);
            logOut.onclick = () => this.signOut();
            popup.appendChild(logOut);
        }
        {
            const deleteAccount = document.createElement('button');
            deleteAccount.className = 'oauth-popup-delete-account';
            deleteAccount.textContent = 'Delete account';
            deleteAccount.onclick = () => {
                if (window.confirm('Delete your account? This cannot be undone.'))
                    this.deleteAccount();
            };
            popup.appendChild(deleteAccount);
        }
        this.presentPopup(popup);
    }
    presentPopup(popup) {
        {
            const rect = this.button.getBoundingClientRect();
            popup.style.position = 'fixed';
            popup.style.top = `${rect.bottom}px`;
            popup.style.right = `${window.innerWidth - rect.right}px`;
        }
        document.body.appendChild(popup);
        this.popup = popup;
        // Keep the popup within the viewport (e.g. on small/mobile screens).
        {
            const margin = 8;
            const rect = popup.getBoundingClientRect();
            if (rect.left < margin) {
                popup.style.right = 'auto';
                popup.style.left = `${margin}px`;
            }
            const bottomOverflow = rect.bottom - (window.innerHeight - margin);
            if (bottomOverflow > 0) {
                const top = Math.max(margin, rect.top - bottomOverflow);
                popup.style.top = `${top}px`;
            }
        }
        const onOutsideClick = (e) => {
            const target = e.target;
            if (!popup.contains(target) && !this.button.contains(target))
                this.hidePopup();
        };
        document.addEventListener('click', onOutsideClick, true);
        this.closePopup = () => document.removeEventListener('click', onOutsideClick, true);
    }
    hidePopup() {
        var _a, _b;
        (_a = this.closePopup) === null || _a === void 0 ? void 0 : _a.call(this);
        this.closePopup = undefined;
        (_b = this.popup) === null || _b === void 0 ? void 0 : _b.remove();
        this.popup = undefined;
    }
    dispose() {
        this.hidePopup();
        this.disposeCalls.forEach(it => it());
    }
}
Oauth.PROVIDER_ICONS = {
    google: 'google',
    instagram: 'instagram',
    microsoft: 'microsoft',
    apple: 'apple'
};
export default Oauth;
